import { render, staticRenderFns } from "./TitleButton.vue?vue&type=template&id=54d0f232&scoped=true&"
import script from "./TitleButton.vue?vue&type=script&lang=js&"
export * from "./TitleButton.vue?vue&type=script&lang=js&"
import style0 from "./TitleButton.vue?vue&type=style&index=0&id=54d0f232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0f232",
  null
  
)

export default component.exports